module.exports = __webpack_public_path__ + "static/media/11.768da20c.jpg";